import { render, staticRenderFns } from "./skillsTab.vue?vue&type=template&id=b24c169c&scoped=true&"
import script from "./skillsTab.vue?vue&type=script&lang=js&"
export * from "./skillsTab.vue?vue&type=script&lang=js&"
import style0 from "./skillsTab.vue?vue&type=style&index=0&id=b24c169c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24c169c",
  null
  
)

export default component.exports